import { createRoot, hydrateRoot } from "react-dom/client";

// Singleton on globalThis so the Map survives webpack chunk duplication
const g = typeof window !== "undefined" ? window : globalThis;
const roots = g.__reactRootRegistry || (g.__reactRootRegistry = new Map());

export function hydrateInto(container, element) {
    if (roots.has(container)) {
        return roots.get(container);
    }
    const root = hydrateRoot(container, element);
    roots.set(container, root);
    return root;
}

export function renderInto(container, element) {
    let root = roots.get(container);
    if (!root) {
        root = createRoot(container);
        roots.set(container, root);
    }
    root.render(element);
    return root;
}

export function unmountFrom(container) {
    const root = roots.get(container);
    if (root) {
        root.unmount();
        roots.delete(container);
    }
}
